import React from 'react';
import './Whoops.css';

export const WhoopsComponent = () => {

    return (
        <h1>Whoops! Nothing here!</h1>
    )
}

export default WhoopsComponent;



// WEBPACK FOOTER //
// ./src/components/Whoops/Whoops.js